import React from 'react';

function Testimonials() {
  const testimonials = [
    {
      quote: "CerebralMachines transformed how we approach decision-making. The AI's ability to learn from our data and provide actionable insights has been game-changing for our operations.",
      author: "Sarah Chen",
      position: "CTO",
      company: "TechCorp Global",
      rating: 5
    },
    {
      quote: "The level of automation and intelligence we've achieved is unprecedented. What used to take hours now happens in seconds, with better accuracy than our best analysts.",
      author: "Michael Rodriguez",
      position: "VP of Operations",
      company: "Financial Systems Inc",
      rating: 5
    },
    {
      quote: "Implementation was smooth, and the ROI was evident within the first quarter. The continuous learning aspect means it just keeps getting better. Highly recommended.",
      author: "Dr. Emily Watson",
      position: "Chief Data Officer",
      company: "MedTech Solutions",
      rating: 5
    }
  ];

  return (
    <section className="testimonials-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Trusted by Industry Leaders</h2>
          <p className="section-subtitle">
            See what our customers have to say about transforming their business with AI
          </p>
        </div>

        <div className="testimonials-grid">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="testimonial-card">
              <div className="testimonial-rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg key={i} width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M10 1 L12.5 7 L19 7.5 L14 12 L15.5 19 L10 15.5 L4.5 19 L6 12 L1 7.5 L7.5 7 Z"/>
                  </svg>
                ))}
              </div>
              <p className="testimonial-quote">"{testimonial.quote}"</p>
              <div className="testimonial-author">
                <div className="author-avatar">
                  {testimonial.author.split(' ').map(n => n[0]).join('')}
                </div>
                <div className="author-info">
                  <div className="author-name">{testimonial.author}</div>
                  <div className="author-position">{testimonial.position}, {testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="company-logos">
          <div className="logo-marquee">
            <div className="logo-item">TechCorp</div>
            <div className="logo-item">Financial Systems</div>
            <div className="logo-item">MedTech</div>
            <div className="logo-item">DataFlow</div>
            <div className="logo-item">CloudScale</div>
            <div className="logo-item">SecureNet</div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;

